export class VenueRequestWriteContractError extends Error {
  constructor(operation) {
    super(`Invalid ${operation} request.`);
    this.name = 'VenueRequestWriteContractError';
    this.code = 'INVALID_API_REQUEST';
  }
}

const isRecord = value => value !== null && typeof value === 'object' && !Array.isArray(value);
const isObjectId = value => typeof value === 'string' && /^[a-f0-9]{24}$/i.test(value);

export function readVenueRequestIdentifier(value) {
  if (!isObjectId(value)) throw new VenueRequestWriteContractError('venue resource identifier');
  return value;
}

export function readGuardianVenueRequestQuery(input = {}) {
  if (!isRecord(input) || input.status != null && typeof input.status !== 'string'
    || input.limit != null && !['string', 'number'].includes(typeof input.limit)) throw new VenueRequestWriteContractError('guardian venue filters');
  return input;
}

export function readResidenceVenueRequest(payload) {
  if (!isRecord(payload) || !isObjectId(payload.householdId || payload.targetHousehold)
    || (payload.note !== undefined && typeof payload.note !== 'string')) {
    throw new VenueRequestWriteContractError('residence venue');
  }
  return payload;
}

export function readVenueRequestDecisionRequest(payload, decision, guardian = false) {
  if (!isRecord(payload) || (payload.decisionNote !== undefined && typeof payload.decisionNote !== 'string')
    || (guardian && decision === 'approve' && payload.mode !== undefined
      && (typeof payload.mode !== 'string' || (payload.mode.trim() && !['once', 'ongoing'].includes(payload.mode.trim().toLowerCase()))))
    || (decision === 'decline' && !guardian && (typeof payload.decisionNote !== 'string' || !payload.decisionNote.trim()))) {
    throw new VenueRequestWriteContractError(`${guardian ? 'guardian ' : ''}venue ${decision}`);
  }
  return payload;
}
